/**
 * Access token'a düşük seviyeli erişim. authStore bu sağlayıcıyı besler; axios/SSE/SignalR
 * store'a doğrudan bağımlı olmadan token okur (döngüsel import yok).
 */
type TokenGetter = () => string | null;
type Refresher = () => Promise<string | null>;
type Logout = (reason: 'expired' | 'tenant' | 'manual') => void;

let getter: TokenGetter = () => null;
let refresher: Refresher = async () => null;
let logoutHandler: Logout = () => {};
let connectionGetter: () => string | null = () => null;
let sessionGetter: () => string | null = () => null;

export function bindTokenProvider(opts: {
  getAccessToken: TokenGetter;
  refresh: Refresher;
  onLogout: Logout;
  getConnectionId: () => string | null;
  getSessionId: () => string | null;
}) {
  getter = opts.getAccessToken;
  refresher = opts.refresh;
  logoutHandler = opts.onLogout;
  connectionGetter = opts.getConnectionId;
  sessionGetter = opts.getSessionId;
}

export const getAccessToken = () => getter();
export const refreshAccessToken = () => refresher();
export const forceLogout = (reason: Parameters<Logout>[0]) => logoutHandler(reason);
export const getConnectionId = () => connectionGetter();
export const getSessionId = () => sessionGetter();

/** Ortak istek başlıkları (axios dışı fetch/SSE/DevExpress için). */
export function authHeaders(): Record<string, string> {
  const h: Record<string, string> = {};
  const t = getter();
  if (t) h['Authorization'] = `Bearer ${t}`;
  const c = connectionGetter();
  if (c) h['X-Octo-Connection'] = c;
  const s = sessionGetter();
  if (s) h['X-Octo-Session'] = s;
  return h;
}
